// components/chakra/NavbarWithCallToAction/NavbarWithCallToAction.tsx

import {
  Box,
  Button,
  Container,
  Flex,
  HStack,
  Link,
} from "@chakra-ui/react";
import { Logo } from "../../Logo";

import { Link as RouterLink, useLocation } from "react-router-dom";
import { brandConfig } from "../../../brandConfig";
import { useAuth } from "../../../contexts/AuthContext";

interface NavbarProps {
  scrollY?: number;
}

export const NavbarWithCallToAction = ({ scrollY = 0 }: NavbarProps) => {
  const { isAuthenticated } = useAuth();
  const { pathname, search } = useLocation();

  const navbarVisible = scrollY < 100;

  // Real links (right-click / new tab work), 14px — the readability floor.
  const navLink = {
    fontSize: "sm",
    fontWeight: "400",
    letterSpacing: "0.08em",
    textTransform: "uppercase" as const,
    color: "whiteAlpha.900",
    minH: "44px",
    display: "inline-flex",
    alignItems: "center",
    _hover: { color: "#7AB0FF", textDecoration: "none" },
    transition: "color 0.2s",
  };

  return (
    <>
      {/* Fixed navbar */}
      <Box
        position="fixed"
        top={0}
        left={0}
        right={0}
        zIndex={1000}
        bg="rgba(0, 0, 0, 0.85)"
        borderBottom="1px solid"
        borderColor="whiteAlpha.100"
        boxShadow="none"
        backdropFilter="blur(20px)"
        margin={0}
        padding={0}
        width="100%"
        transform={navbarVisible ? "translateY(0)" : "translateY(-100%)"}
        transition="transform 0.3s ease"
      >
        <Container maxW="7xl" px={{ base: 4, md: 6 }}>
          <Flex
            minH={{ base: "60px", md: "72px" }}
            py={{ base: 0, md: 0 }}
            align={"center"}
            justify={"space-between"}
          >
            <Link
              as={RouterLink}
              to="/"
              aria-label={`${brandConfig.siteName} home`}
            >
              {/* Sam (27 Jul 2026): "Logo still so tiny at top left" — bigger in the bar, only here. */}
              <Logo sx={{ img: { height: { base: "52px", md: "64px" } } }} />
            </Link>

            <HStack spacing={{ base: 3, md: 6 }} align="center">
              <HStack spacing={6} display={{ base: "none", md: "flex" }}>
                <Link as={RouterLink} to="/about" {...navLink}>About Us</Link>
                <Link as={RouterLink} to="/providers" {...navLink}>For Health Providers</Link>
              </HStack>
              {isAuthenticated ? (
                <Button as={RouterLink} to="/lm/dashboard" size="sm" minH="44px" px={4} borderRadius="full" variant="outline"
                  borderColor="whiteAlpha.400" color="white" fontSize="sm" fontWeight="600" _hover={{ bg: "whiteAlpha.100" }}
                  title="Open your courses and progress">
                  My courses
                </Button>
              ) : (
                <Button as={RouterLink} to="/login" state={pathname === "/login" ? undefined : { from: { pathname, search } }}
                  size="sm" minH="44px" px={5} borderRadius="full" bg="#7AB0FF" color="#0b0f14" fontSize="sm" fontWeight="700"
                  _hover={{ bg: "#5F98FF" }} title="Sign in to your SurgReady account">
                  Log in
                </Button>
              )}
            </HStack>

          </Flex>
        </Container>
      </Box>

      {/* Spacer to prevent content from hiding behind fixed navbar */}
      <Box h={{ base: "60px", md: "72px" }} />
    </>
  );
};
